import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue'
import SeletorDePotencia from '@/components/SeletorDePotencia.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { Filtro } from '../modules/AgendaModule'
import { IGrauDeSessao } from '../../common/types/Evento'
import { tiposDeSessaoParcial } from '../shareds/sharedsEvento'


const __default__ = {
	model: {
		prop: 'filtro',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FiltroDaAgenda',
  props: {
	default: {
		type: Object as PropType<Filtro>,
		default: () => ({
			potencia: null,
			loja: null,
			grau: null,
			tipoDaSessao: null,
		} satisfies Filtro),
	},
	filtro: {
		type: Object as PropType<Filtro>,
		required: true,
	},
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', filtro: Filtro): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const mostra = ref(false)

const tiposDeSessao = tiposDeSessaoParcial

const grausDeSessao: IGrauDeSessao[] = [
	'Grau 1',
	'Grau 2',
	'Grau 3',
]

const temFiltro = computed(() => JSON.stringify(props.default) !== JSON.stringify(props.filtro))

watch(() => props.filtro, (filtro) => {
	emit('input', filtro)
})

function limpar() {
	emit('input', { ...props.default })
	mostra.value = false
}

return { __sfc: true,props, emit, mostra, tiposDeSessao, grausDeSessao, temFiltro, limpar, SeletorDePotencia, SeletorDeLojas }
}

})